/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sreality_Seller_Mode_ExistingInputs */

const cs_sreality_seller_mode_existing = /** @type {(inputs: Sreality_Seller_Mode_ExistingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Propojit existujícího makléře (z portálu)`)
};

const en_sreality_seller_mode_existing = /** @type {(inputs: Sreality_Seller_Mode_ExistingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Link existing seller (from portal)`)
};

/**
* | output |
* | --- |
* | "Link existing seller (from portal)" |
*
* @param {Sreality_Seller_Mode_ExistingInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const sreality_seller_mode_existing = /** @type {((inputs?: Sreality_Seller_Mode_ExistingInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sreality_Seller_Mode_ExistingInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_sreality_seller_mode_existing(inputs)
	return cs_sreality_seller_mode_existing(inputs)
});